
import { ActionsWithLargePayloadData, TAction } from '../actions/calcactions';
import { ActionTypes } from '../types/types';
import { CalculatorState, initialState } from '../state/calculatorstate';

import { Resources } from '../ui/resources';
import { isScopeAction, isValidJsonString } from '../utils/calculatorutils';

export function calcAppReducer(state = initialState, action: TAction) {
    const { type, payload } = action;

    const getAllRepeatingActionsHelper = (definition: any, allActions: string[], allRepeatingActions: string[], repeatingActionsIterations: Record<string, number>): void => {
        const actions = definition.actions;
        if ((actions && Object.keys(actions).length === 0) || !actions) {
            return;
        }

        for (let action of Object.keys(actions)) {
            if (!isScopeAction(actions[action].type)) {
                allActions.push(action);
            }
            if (actions[action].type && (actions[action].type === Resources.ACTION_TYPE_FOREACH || actions[action].type === Resources.ACTION_TYPE_UNTIL)) {
                allRepeatingActions.push(action);
                repeatingActionsIterations[action] = 1;
            }
            getAllRepeatingActionsHelper(actions[action], allActions, allRepeatingActions, repeatingActionsIterations);
        }
    }

    const parseWorkflow = (workflowDefinition: string): Partial<CalculatorState> => {
        const workflowDefinitionObj = workflowDefinition && isValidJsonString(workflowDefinition) && JSON.parse(workflowDefinition);
        const definition = workflowDefinitionObj && workflowDefinitionObj.definition;
        let allActions: string[] = [];
        let allRepeatingActions: string[] = [];
        let repeatingActionsIterations: Record<string, number> = {};
        if (definition) {
            getAllRepeatingActionsHelper(definition, allActions, allRepeatingActions, repeatingActionsIterations);
        }
        return {
          repeatingActions: allRepeatingActions,
          repeatingActionsIterations,
          workflowActions: allActions
        };
    };

    const selectAllActionsWithLargePayload = (payload: boolean): string[] => {
      if (payload) { // Select All
          return state.workflowActions;
      } else { // Unselect All
          return [];
      }
  };

    const updateActionsWithLargePayload = (payload: ActionsWithLargePayloadData): string[] => {
        let actions = state.allActionsWithLargePayload;
        if (payload.toAdd) {
            actions.push(payload.action);
        } else {
            const index = actions.indexOf(payload.action);
            actions = [...state.allActionsWithLargePayload.slice(0, index), ...state.allActionsWithLargePayload.slice(index + 1)]
        }
        return actions;
    };

    const updateWorkflowDefinition = (payload: string): CalculatorState => {
        let errorMessage = '';
        let allActions: string[] = [];
        let repeatingActions: string[] = [];
        let repeatingActionsIterations: Record<string, number> = {};

        if (!isValidJsonString(payload)) {
            errorMessage = Resources.INVALID_JSON_TEXT;
        } else {
            const parseResults = parseWorkflow(payload);
            allActions = parseResults.workflowActions || [];
            repeatingActions = parseResults.repeatingActions || [];
            repeatingActionsIterations = parseResults.repeatingActionsIterations || {};
        }

        return {
            ...state,
            allActionsWithLargePayload: [],
            errorMessage,
            repeatingActions,
            repeatingActionsIterations,
            hasLargeActions: false,
            isSelectAllActionsWithLargePayloadChecked: false,
            operationCountData: {
              blobReadMin: 0,
              blobReadMax: 0,
              blobReadBestGuess: 0,
              blobWriteMin: 0,
              blobWriteMax: 0,
              blobWriteBestGuess: 0,
              queueMin: 0,
              queueMax: 0,
              queueBestGuess: 0,
              tableMin: 0,
              tableMax: 0,
              tableBestGuess: 0
            },  
            workflowActions: allActions,
            workflowDefinition: payload
        }
    };

    const updateRepeatingActionsIterations = (repeatingActionsIterations: Record<string, number>): Record<string, number> => {
        let updatedRepeatingActionsIterations = state.repeatingActionsIterations;

        if (Object.keys(repeatingActionsIterations).length === 0) {
          updatedRepeatingActionsIterations = {};
        } else {
            for (const action of Object.keys(repeatingActionsIterations)) {
              updatedRepeatingActionsIterations[action] = repeatingActionsIterations[action];
            }
        }
        return updatedRepeatingActionsIterations;
    };

    switch (type) {
      case ActionTypes.SELECT_ALL_ACTIONS_WITH_LARGE_PAYLOAD_CLICKED: {
        return {
          ...state,
          allActionsWithLargePayload: selectAllActionsWithLargePayload(payload),
          isSelectAllActionsWithLargePayloadChecked: payload
        };
      }
      case ActionTypes.UPDATE_CALCULATE_CLICKED: {
        return {
          ...state,
          isCalculateClicked: payload
        };
      }
      case ActionTypes.UPDATE_ACTIONS_WITH_LARGE_PAYLOADS: {
        return {
            ...state,
            allActionsWithLargePayload: updateActionsWithLargePayload(payload),
            isSelectAllActionsWithLargePayloadChecked: false
        };
      }
      case ActionTypes.UPDATE_CALCULATE_BUTTON_TEXT: {
        return {
          ...state,
          calculateButtonText: payload
        };
      }
      case ActionTypes.UPDATE_ERROR_MESSAGE: {
        return {
          ...state,
          errorMessage: payload
        };
      }
      case ActionTypes.UPDATE_REPEATING_ACTIONS_ITERATIONS: {
        return {
          ...state,
          repeatingActionsIterations: updateRepeatingActionsIterations(payload)
        };
      }
      case ActionTypes.UPDATE_MONTHLY_RUNS: {
        return {
          ...state,
          monthlyRuns: payload
        };
      }
      case ActionTypes.UPDATE_OPERATION_COUNT_DATA: {
        return {
          ...state,
          operationCountData: payload
        };
      }
      case ActionTypes.UPDATE_WORKFLOW_DEFINITION: {
        return updateWorkflowDefinition(payload)
      }
      default:
        return state
    }
}